// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"99d3041e91b32426c73f","339":"52959e9e910c5b80cc5c"}[chunkId] + ".js";
};